import ProductCatalogue from './ProductCatalogue';
import ProductPromos from './ProductPromos';
import ProductAgencies from './ProductAgencies';
import ProductQuality from './ProductQuality';
import ProductDatasheets from './ProductDatasheets';
import ProductSearch from './ProductSearch';

/**
 * Routing class for ProductsPage tabs
 */
class ProductsTabs {
  constructor() {
    this.tabs = document.querySelectorAll('.product__tabs li');
    this.container = document.querySelector('.product__tabcontent');
    this.dropdown = document.querySelector(`.product__menu--select`);
    this.searchselect = document.querySelector('.product__search--select');

    this.cc = document.body.dataset.country === 'AU'?'AU':'NZ';

    const loc = location.pathname.split('/');
    const tabarray = ['products', 'promos', 'agencies', 'quality', 'datasheets'];
    // prevent error from trailing slash
    this.page = loc[loc.length - 1] || loc[loc.length - 2];
    // check that this.page is a tab. If not switch to products tab.
    if(!tabarray.includes(this.page)) this.page = null;

    this.contenttop = this.container.getBoundingClientRect().top;

    // set search select to currently selected category
    try {
      const url = new URL(location.href);
      const path = url.pathname.replace(/\/$/, '');
      for(var option of this.searchselect.options) {
        var slug = '/'+option.dataset.slug;
        var regex = new RegExp(slug+'$');
        if (path.search(regex)!==-1) {
          this.searchselect.value=option.value;
        }
      }
    } catch(e) {
      console.debug(e);
    }

    const productSearch = new ProductSearch();
    this.content;
    this.events();
    this.init();
  }

  events() {
    this.tabs.forEach(tab => {
      tab.addEventListener('click', this.showTab.bind(this));
    })

    this.dropdown.addEventListener('change', this.showTab.bind(this));
    if (this.searchselect !== null) {
      this.searchselect.addEventListener('change', this.showCategory.bind(this));
    }
  }

  init() {
    this.showTab();
  }

  /**
   * Determine which tab has been clicked/dropdown selected
   * Create appropriate tab page object
   * @param {Event} e 
   */
  showTab(e) {
    let page, tab, select;
    // Detect if trigger by click or page refresh
    if(e !== undefined) {
      
      // on click
      tab = e.target;
      //let currentSection = tab.dataset.tab;
      // switch(currentSection) {
      //   case 'promos':
      //     location.href = '/products/promos';
      //   break;
      //   case 'agencies':
      //     location.href = '/products/agencies';
      //   break;
      //   case 'quality':
      //     location.href = '/products/quality';
      //   break;
      //   case 'datasheets':
      //     location.href = '/products/datasheets';
      //   break;
      //   case 'products':
      //   default:
      //     location.href = '/products';
      // }

      page = tab.dataset.tab || tab.value;
    } else {
      // on load page

      page = this.page;
      tab = document.querySelector(`.product__tabs li[data-tab="${page}"]`);
    }

    if(page !== null) {
      this.tabs.forEach(tab => {
        tab.classList.remove('selected');
      });
      tab.classList.add('selected'); // highlight tab menu item
      this.dropdown.value = page; // select dropdown menu item
      // Clear container content to reduce perseption of delay
      this.container.innerHTML = '';
    }
    // Select appropriate Class to fetch content
    switch(page) {
      case 'promos':
        history.pushState('', 'Promos', '/products/promos');
        this.content = new ProductPromos();
      break;
      case 'agencies':
        history.pushState('', 'Agencies', '/products/agencies');
        this.content = new ProductAgencies();
      break;
      case 'quality':
        history.pushState('', 'Quality', '/products/quality');
        this.content = new ProductQuality();
      break;
      case 'datasheets':
        history.pushState('', 'Datasheets', '/products/datasheets');
        this.content = new ProductDatasheets();
      break;
      case null:
        this.content = new ProductCatalogue();
      break;
      case 'products':
      default:
        history.pushState('', 'ProductCatalogue', '/products');
        this.content = new ProductCatalogue();
      
    }
  }

  /**
   * Ajax function to retrieve Category Url from the ID
   * Go to Category URL
   * 
   * @param {Event} e 
   */
  showCategory(e) {
    const url = "/productapi/categoryurl/" + this.cc + "/" + e.target.value;

    fetch(url,{
      method: 'GET',
      headers: {
        'Content-Type':'text/html',
        'x-requested-with': 'XMLHttpRequest'
      }
    })
    .then(response => response.text())
    .then(data => {
      location.href = data;
    })
  }
}

export default ProductsTabs;